module.exports = __webpack_public_path__ + "static/media/before.994a8d34.svg";